import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { AsyncError, Loadable } from '../Loadable';
import { Alert } from '@mui/material';
import { FormattedMessage } from 'react-intl';


interface Props {
  content: React.ReactNode | false;
}

export function LoadingWrapper(props: Props) {
  return (
    <React.Fragment>
      {props.content ? props.content : (<CircularProgress />)}
    </React.Fragment>
  );
}



interface PropsNew {
  content: React.ReactNode | false;
  fallbackContent?: (error: AsyncError[]) => (React.ReactNode | null);
  // If true, fallback content is ignored and content is shown whenever loading is finished
  ignoreErrors?: boolean;
  waitingFor?: Loadable<any>[];
  // If undefined, defaults to true. 
  center?: boolean,
}

function ErrorView() {
  return (
    <Alert severity='error' style={{ width: '100%', }}>
      <FormattedMessage id={'common.error'} />
    </Alert>
  );
}

function LoadingView({ center }: { center?: boolean }) {
  return (
    <div style={
      (center === undefined || center) ? { display: "flex", justifyContent: "center", alignItems: "center" } : {}}>
      <CircularProgress />
    </div>
  );
}

export function LoadingWrapperNew(props: PropsNew) {
  const isError: boolean = props.waitingFor?.some(v => Loadable.isError(v)) ?? false;
  const errors: AsyncError[] =
    props.waitingFor?.map(v => v.loadingError).filter((v): v is AsyncError => (v !== undefined)) ?? [];
  const isLoaded: boolean = props.waitingFor?.every(v => Loadable.isFinished(v)) ?? true;

  function getFallbackContent() {
    if (!props.fallbackContent) {
      return (<ErrorView />);
    }
    const fallbackContent = props.fallbackContent(errors);
    if (!fallbackContent) {
      return (<ErrorView />);
    }
    return fallbackContent;
  }

  return (
    <React.Fragment>
      {(isError && !props.ignoreErrors)
        ? getFallbackContent()
        : (isLoaded && props.content) ? props.content : (<LoadingView center={props.center} />)}

    </React.Fragment>
  );
}
